import store, { useRtfix } from '@/store'
import { getShopInfo, publishProduct } from '@/apis/user'
import { ElMessageBox } from 'element-plus'
import { t } from '@/plugins/i18n'
import router from '@/router'
import { confirmApiUnbind } from '@/util/useConfirm'

/**
 * 一键上新
 */
export default async ({ productCode, channel }: any, languageCode: any): Promise<void> => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const customerShopId = store.getters.curShop
    const unbind = await confirmApiUnbind()
    if (unbind) return
    const shop = await getShopInfo({ customerShopId }).then((res) => res.data)
    if (shop.customerShopAuthStatus !== 1) {
      ElMessageBox.alert(
        t('仅支持已授权店铺上传商品，该店铺未授权'),
        t('传输商品信息到店铺'),
        {
          confirmButtonText: t('去授权'),
          type: 'warning',
          closeOnClickModal: true
        }
      )
        .then(() => {
          router.push(useRtfix('AuthorizedStore'))
        })
        .catch(() => { })
    } else {
      ElMessageBox.alert(t('上传中...'), t('传输商品信息到店铺'), {
        showConfirmButton: false,
        customClass: 'stupid-el',
        type: 'success'
      }).catch(() => { })
      // if (shop.customerShopPlatform === 1) {
      //   // todo:base
      // } else if (shop.customerShopPlatform === 2) {
      // }
      await publishProduct({ productCode, languageCode, purchaseChannel: channel }).then(
        (res) => {
          const a: any = document.querySelector('.stupid-el')
          if (a) {
            const m = a.parentNode.parentNode
            m.parentNode.removeChild(m)
          }
          if (res.success) {
            resolve()
            ElMessageBox.alert(
              t('创建成功，并已为您自动创建关联'),
              t('传输商品信息到店铺'),
              {
                confirmButtonText: t('查看关联商品库'),
                type: 'success',
                closeOnClickModal: true
              }
            )
              .then(() => {
                router.push(useRtfix('AssociatedProductlib'))
              })
              .catch(() => { })
          }
        }
      )
    }
  })
}
